export enum EUserType {
  HOME_OWNER = 'homeowner',
  USER = 'user',
}
